import React, { PropsWithChildren } from "react";
import "./main-banner.css";
import { Container } from "@mui/material";
import cx from "classnames";

export interface MainBannerProps {
  imageBanner: string;
  isMunicipalityHome?: boolean;
}
export const MainBanner = ({
  imageBanner,
  isMunicipalityHome,
  children,
}: PropsWithChildren<MainBannerProps>) => {
  return (
    <div
      className="xvia-main-banner"
      style={{
        backgroundImage: `url("${imageBanner}")`,
      }}
    >
      <div
        className={cx("xvia-main-banner__content-wrapper", {
          "xvia-main-banner__content-wrapper--municipality": isMunicipalityHome,
        })}
      >
        <Container className="xvia-main-banner__content">{children}</Container>
      </div>
    </div>
  );
};
